import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Announces a table's result count to screen readers when a filter or search changes it, including "No results".
 * CCL's aw-footer shows the count as plain text (no live region) and nothing at 0. Visually hidden; sits beside it.
 */
@Component({
  selector: 'app-results-status',
  template: `<div class="results-status" role="status" aria-live="polite">{{ message() }}</div>`,
  styles: `
    .results-status {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0 0 0 0);
      white-space: nowrap;
      border: 0;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsStatusComponent {
  count = input.required<number>();

  readonly message = computed(() => {
    const count = this.count();
    if (count === 0) {
      return 'No results';
    }
    return `${count} ${count === 1 ? 'result' : 'results'}`;
  });
}
